import { writingTags } from "../content/chinese/language-tags.js";
import type { ToolOptions } from "./options.js";

/**
 * The Chinese a reader has asked the site to write, as the tools name it.
 *
 * `head/reader-settings.html` puts the choice on `<html>` as `data-cb-writing`
 * before the page is painted, and it is what every 例句 on the site is drawn
 * from. A converter that opened on 简体 for somebody who reads 繁體 everywhere
 * else would be the one page on the site that ignored them.
 *
 * **It seeds the panel rather than overriding it.** A reader who sets the
 * converter's own control to 简体 while reading the site in 繁體 has said
 * something more specific, and that is what is stored and what comes back next
 * visit. See `ToolSettings` for the whole order.
 *
 * `writingTags` is where the mapping lives, since the site names three writings
 * and `@kensio/pinyinjs` knows two locales. Hong Kong reads as the mainland
 * does, and that sentence is written down once.
 */
export function readerLocale(page: Document): ToolOptions["locale"] {
  const chosen = page.documentElement.getAttribute("data-cb-writing");

  if (chosen === null) {
    return writingTags["zh-CN"].locale;
  }

  return (
    writingTags[chosen as keyof typeof writingTags]?.locale ??
    writingTags["zh-CN"].locale
  );
}
